import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import './layout.scss';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

//creates a Button that opens a modal dialog with info
//dialog content is raw html, sent in as a prop.
//if no linkText supplied, it uses a little info circle as the button to open the modal.
//if no color supplied, it renders the button as text, like a link
function LearnMoreModal(props){
  const {
    linkText,
    title,
    content,
    buttonClassName,
    color
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const location = useLocation();

  useEffect(() => {
    if (isModalOpen) {
      var url = props.location ? props.location.pathname + props.location.search : location.pathname + location.search;
      ReactGA.event({
        category: title,
        action: 'learn_more_modal',
        label: url
      });
    }
  }, [isModalOpen]);

  //can't figure out how to just conditionally render the text within the <Button>, so do this instead:
  const renderHelpBtn = () => {
    if (linkText){
      return(
        <Button className={buttonClassName} color={color || "link"} onClick={toggleModal}>{linkText}</Button>
      );
    }
    else{
      return(
        <Button className={buttonClassName} color={"link"} onClick={toggleModal}><span className='fa fa-info-circle aa-fa-115x'></span></Button>
      );
    }
  }
  //use animation={false} with Modal to avoid findDOMNode deprecation warning (but that will turn off the pretty transition)
 // https://github.com/reactstrap/reactstrap/issues/1289  
 if(content){
    const htmlContent={
      __html: content
    }
    return(
    <>
      {renderHelpBtn()}
      <Modal isOpen={isModalOpen} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>{title}</ModalHeader>
        <ModalBody><span dangerouslySetInnerHTML={ htmlContent }></span></ModalBody>      
      </Modal>
    </>
    );
  }
  else{
    return(
      <>
      </>
    );
  }
}

export default LearnMoreModal;

// challenges getting small images to render, when passed in to dangerouslySetInnerHTML
// attempts using import smallImage from './small.png';
// {/* DOES display the small image: <ModalBody><img src={smallImage}/></ModalBody> */}
// {/* does not display the small image, smallImage used literally: <ModalBody><span dangerouslySetInnerHTML={{__html: `<img src={smallImage}/>`}}></span></ModalBody> */}
// {/* does not display: image is base64 <ModalBody><span dangerouslySetInnerHTML={{__html: `<img src=${smallImage}/>`}}></span></ModalBody> */}
// attempts using require()
// {/* DOES display the small image: <ModalBody><img src={require("./small.png")}/></ModalBody> */}
// {/* does not display: image is base64 <ModalBody><span dangerouslySetInnerHTML={{__html: `<img src=${require("./small.png")}/>`}}></span></ModalBody> */}   
// ** WHAT DOES WORK is putting the image in /public.
